import { render, staticRenderFns } from "./EditActor.vue?vue&type=template&id=046946ca&"
import script from "./EditActor.vue?vue&type=script&lang=js&"
export * from "./EditActor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports